import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StoreRequestCreate, StoreRequestFindAll, StoreRequestPublish, StoreRequestSearch, StoreRequestSearchForOpeningClosingHours, StoreRequestUpdate, StoreRequestSearchForAppointmentsOpeningClosingHours, StoreRequestAccessories, StoreRequestDocuments, StoreRequestGalleries, StoreRequestHeadImage, StoreRequestInternalGalleries, StoreRequestProductServices, StoreRequestPromotionEvent, StoreRequestUpdateMassiveWhatsapp } from '../../../models/api-store/store/store.request.model';
import { StoreResponseAccessory, StoreResponseAddAccessories, StoreResponseAddDocuments, StoreResponseAddGalleries, StoreResponseAddHeadImage, StoreResponseAddInternalGalleries, StoreResponseAddProductServices, StoreResponseExportCSV, StoreResponseFindAll, StoreResponsePublish, StoreResponseRemoveAccessories, StoreResponseRemoveDocuments, StoreResponseRemoveGalleries, StoreResponseRemoveHeadImage, StoreResponseRemoveInternalGalleries, StoreResponseRemoveProductServices, StoreResponseSearch, StoreResponseSearchForOpeningClosingHours, StoreResponseSearchForAppointmentsOpeningClosingHours, StoreResponse } from '../../../models/api-store/store/store.response.model';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  constructor(private http: HttpClient) { }
  pathUrl: string = environment.backend.pathUrl.store.store;
  baseUrl: string = environment.backend.baseUrl_backend;
  url: string = this.baseUrl + this.pathUrl;

  /**createParams
       * @param objectStoresParams 
       * @returns params
       * Prende in input un oggetto e lo trasforma in un HttpParams
       */
   createParams(objectStoresParams: any) {
    let params = new HttpParams();
    for (let property in objectStoresParams) {
      if (objectStoresParams.hasOwnProperty(property)) {
        params = params.append(property, objectStoresParams[property]);
      }
    }
    return params;
  }


  findAll(request: StoreRequestFindAll): Observable<StoreResponseFindAll> {
    let url = this.url;
    let params = this.createParams(request);
    return this.http.get<StoreResponseFindAll>(url, { params: params });
  }

  create(request: StoreRequestCreate): Observable<StoreResponse> {
    let url = this.url;
    return this.http.post<StoreResponse>(url, request);
  }

  getEntity(id: number): Observable<StoreResponse> {
    let url = this.url + "/" + id;
    return this.http.get<StoreResponse>(url);
  }

  update(id: number, request: StoreRequestUpdate): Observable<StoreResponse> {
    let url = this.url + "/" + id;
    return this.http.put<StoreResponse>(url, request);
  }

  delete(id: number) {
    let url = this.url + "/" + id;
    return this.http.delete<any>(url);
  }

  getAccessory(id: number): Observable<StoreResponseAccessory[]>{
    let url = this.url + "/" + id + "/accessory";
    return this.http.get<StoreResponseAccessory[]>(url);
  }

  addAccessories(id: number, request: StoreRequestAccessories): Observable<StoreResponseAddAccessories[]>{
    let url = this.url + "/" + id + "/addAccessories";
    return this.http.put<StoreResponseAddAccessories[]>(url, request.accessoryIds);
  }
  
  addDocuments(id: number, request:StoreRequestDocuments): Observable<StoreResponseAddDocuments>{
    let url = this.url + "/" + id + "/addDocuments";
    return this.http.put<StoreResponseAddDocuments>(url, request.documentIds);
  }

  addGalleries(id: number, request:StoreRequestGalleries): Observable<StoreResponseAddGalleries>{
    let url = this.url + "/" + id + "/addGalleries";
    return this.http.put<StoreResponseAddGalleries>(url, request.galleryIds);
  }

  addHeadImage(id: number, request:StoreRequestHeadImage): Observable<StoreResponseAddHeadImage>{
    let url = this.url + "/" + id + "/addHeadImage";
    return this.http.put<StoreResponseAddHeadImage>(url, request.headImageId);
  }

  addInternalGalleries(id: number, request:StoreRequestInternalGalleries): Observable<StoreResponseAddInternalGalleries>{
    let url = this.url + "/" + id + "/addInternalGalleries";
    return this.http.put<StoreResponseAddInternalGalleries>(url, request.galleryIds);
  }

  addProductServices(id: number, request:StoreRequestProductServices): Observable<StoreResponseAddProductServices>{
    let url = this.url + "/" + id + "/addProductServices";
    return this.http.put<StoreResponseAddProductServices>(url, request.productServices);
  }

  addPromotionEvent(id: number, request:StoreRequestPromotionEvent): Observable<StoreResponse>{
    let url = this.url + "/" + id + "/addPromotionEvent";
    return this.http.put<StoreResponse>(url, request.promotionEventsIds);
  }

  publish(id:number,published:boolean):Observable<StoreResponsePublish>{
    let url = this.url+"/"+id+"/publish?published="+published;
    let request = new StoreRequestPublish();
    request.published = published;
    return this.http.put<StoreResponsePublish>(url,request);
  }

  removeAccessories(id:number, request:StoreRequestAccessories): Observable<StoreResponseRemoveAccessories>{
    let url = this.url + "/" + id + "/removeAccessories";
    return this.http.put<StoreResponseRemoveAccessories>(url, request.accessoryIds);
  }

  removeDocuments(id:number, request:StoreRequestDocuments): Observable<StoreResponseRemoveDocuments>{
    let url = this.url + "/" + id + "/removeDocuments";
    return this.http.put<StoreResponseRemoveDocuments>(url, request.documentIds);
  }

  removeGalleries(id:number, request:StoreRequestInternalGalleries): Observable<StoreResponseRemoveGalleries>{
    let url = this.url + "/" + id + "/removeGalleries";
    return this.http.put<StoreResponseRemoveGalleries>(url, request.galleryIds);
  }

  removeHeadImage(id:number): Observable<StoreResponseRemoveHeadImage>{
    let url = this.url + "/" + id + "/removeHeadImage";
    return this.http.put<StoreResponseRemoveHeadImage>(url,{});
  }

  removeInternalGalleries(id:number, request:StoreRequestInternalGalleries): Observable<StoreResponseRemoveInternalGalleries>{
    let url = this.url + "/" + id + "/removeInternalGalleries";
    return this.http.put<StoreResponseRemoveInternalGalleries>(url, request.galleryIds);
  }

  removeProductServices(id:number, request:StoreRequestProductServices): Observable<StoreResponseRemoveProductServices>{
    let url = this.url + "/" + id + "/removeProductServices";
    return this.http.put<StoreResponseRemoveProductServices>(url, request.productServices);
  }

  removePromotionEvent(id: number, request:StoreRequestPromotionEvent): Observable<StoreResponse>{
    let url = this.url + "/" + id + "/removePromotionEvent";
    return this.http.put<StoreResponse>(url, request.promotionEventsIds);
  }

  exportCSV(): Observable<StoreResponseExportCSV>{
    let url = this.url + "/exportCsv";
    return this.http.post<StoreResponseExportCSV>(url,{});
  }

  updateMassiveFlag(request:any): Observable<any>{
    let url = this.url + "/massiveFlags";
    return this.http.put<any>(url, request);
  }

  search(request:StoreRequestSearch):Observable<StoreResponseSearch>{
    let url = this.url+"/search";
    return this.http.post<StoreResponseSearch>(url,request);
  }

  searchForAppointmentsOpeningClosingHours(request:StoreRequestSearchForAppointmentsOpeningClosingHours):Observable<StoreResponseSearchForAppointmentsOpeningClosingHours>{
    let url = this.url+"/searchForAppointmentsOpeningClosingHours";
    return this.http.post<StoreResponseSearchForAppointmentsOpeningClosingHours>(url,request);
  }

  searchForOpeningClosingHours(request:StoreRequestSearchForOpeningClosingHours):Observable<StoreResponseSearchForOpeningClosingHours>{
    let url = this.url+"/searchForOpeningClosingHours";
    return this.http.post<StoreResponseSearchForOpeningClosingHours>(url,request);
  }

  findAllDealerCategories():Observable<any>{
    let url = this.url + "/allDealerCategories";
    return this.http.get<any[]>(url);
  }

  updateMassiveWhatsapp(id: number, request: StoreRequestUpdateMassiveWhatsapp): Observable<StoreResponse>{
    let url = this.url + "/" + id + "/whatsapp";
    return this.http.put<StoreResponse>(url, request.whatsapp);
  }
  
}
